import { isMacOs } from "react-device-detect";

export const isMacSafariWebView = (userAgent: string) => {
  const isWKWebView =
    userAgent.includes("AppleWebKit") &&
    !userAgent.includes("Chrome") &&
    !userAgent.includes("Chromium");
  return isMacOs && isWKWebView;
};
